import axios from 'axios';
import {
  IDiscountBrand,
  ICreateDiscountBrandPayload,
  IDeleteDiscountBrandPayload,
  IDiscountBrandCollection,
  IDiscountBrandListParams,
  IUpdateDiscountBrandPayload,
} from 'entities/Discount/Discount.models';

const basePath = 'discount';

export const discountTransport = {
  get: (params: IDiscountBrandListParams): Promise<IDiscountBrandCollection> => axios.get(`${basePath}/brand`, { params }),
  create: (payload: ICreateDiscountBrandPayload): Promise<IDiscountBrand> => axios.post(`${basePath}/brand`, payload),
  update: (payload: IUpdateDiscountBrandPayload): Promise<IDiscountBrand> => axios.patch(`${basePath}/brand`, payload),
  delete: (payload: IDeleteDiscountBrandPayload): Promise<IDiscountBrand> => axios.delete(`${basePath}/brand`, { data: payload }),
};
